import { useEffect, useState } from "react";
import useEbayCategories from "../../data/useEbayCategories";
import SelectInput from "../shared/Inputs/SelectInput";
import LoadingWheel from "../shared/LoadingWheel";
import useEbayConditions from "../../data/useEbayConditions";

interface EbayCategoryDropdownProps {
  categoryId: string;
  register: any;
  registerName: string;
  setValue: any;
  watch: any;
}

export function EbayConditionDropdown({ categoryId, register, registerName, setValue, watch }: EbayCategoryDropdownProps) {
  const { conditions } = useEbayConditions(categoryId);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!conditions.isLoading && conditions.data) {
      const currentId = watch(registerName);
      if (!currentId) {
        const first = conditions.data.conditions[0];
        setValue(registerName, first.id);
        setValue("conditionName", first.name);
      } else {
        const found = conditions.data.conditions.find((c: any) => c.id == currentId);
        if (found) setValue("conditionName", found.name);
      }

      setLoading(false);
    }
  }, [conditions.data, conditions.isLoading])

  useEffect(() => {
    if (conditions.isLoading) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [categoryId, conditions.isLoading]);

  const setValueWithName = (name: string, value: any) => {
    setValue(name, value);
    if (name === registerName && conditions.data) {
      const found = conditions.data.conditions.find((c: any) => c.id == value);
      if (found) setValue("conditionName", found.name);
    }
  };

  if (loading || conditions.isLoading || !conditions.data) {
    return (
      <div className="flex items-center space-x-2">
        Getting conditions from eBay...
        <span className="h-6">
          <LoadingWheel />
        </span>
      </div>
    );
  } else {
    return (
      <SelectInput
        label={"Condition*"}
        register={register}
        registerName={registerName}
        options={conditions.data!.conditions}
        setValue={setValueWithName}
        watch={watch}
      />
    );
  }
}
